import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import ProgressCompDzIndicator from './ProgressCompDzIndicator';

import './style.scss';

export const StatisticsCompletedHomework = ({ count, countCl, countDz, clPercentage, dzPercentage, text, icon }) => {
  const { t } = useTranslation();

  return (
    <div className="completed-homework-block">
      <div className="completed-homework-left">
        <div className="completed-homework-block-top">
          <div className="completed-homework-text">
            <span className="completed-homework-count">
              {count} {'ДЗ'}
            </span>
            <span className="completed-homework-count-text">{t(text)}</span>
          </div>
        </div>
        <div className="completed-homework-block-bottom">
          <div className="completed-homework-info-block">
            <div className="completed-homework-info-item first">
              <span className="icon"></span>
              <span className="name">КЛ</span>
              <span className="count">{countCl} КЛ</span>
              <span className="persent">{clPercentage}%</span>
            </div>

            <div className="completed-homework-info-item second">
              <span className="icon"></span>
              <span className="name">{t('notebook')}</span>
              <span className="count">{countDz} ДЗ</span>
              <span className="persent">{dzPercentage}%</span>
            </div>
          </div>
        </div>
      </div>

      <div className="completed-homework-right">
        {count > 0 && <ProgressCompDzIndicator totalMaterials={count} sentMaterials={countDz} iconImg={icon} />}

        {!count && !countDz && <ProgressCompDzIndicator totalMaterials={0} sentMaterials={0} iconImg={icon} />}
      </div>
    </div>
  );
};
